export const getRecaptchaToken = (action = 'signin'): Promise<string> => {
  return new Promise((resolve, reject) => {
    if (!window.grecaptcha) {
      return reject(new Error('reCAPTCHA not loaded. Missing recaptcha site key.'));
    }

    window.grecaptcha.ready(async () => {
      try {
        const token = await window.grecaptcha.execute(
          process.env.REACT_APP_GOOGLE_RECAPTCHA_SITEKEY ?? '',
          { action }
        );
        resolve(token);
      } catch (err) {
        resolve('');
      }
    });
  });
};
